// extracted by mini-css-extract-plugin
export var dropdown = "_rv-0";
export var imageWrapper = "_rv-3";
export var itemNameContainer = "_rv-1";
export var productImage = "_rv-2";
export var spinnerWrapper = "_rv-4";